// Dependencies
import {
  EMPLEADOS_REQUEST,
  EMPLEADOS_REFRESH,
  EMPLEADOS_OK,
  EMPLEADOS_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
  refreshing: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case EMPLEADOS_REQUEST:
      return { ...state, loading: true };
    case EMPLEADOS_REFRESH:
      return { ...state, refreshing: true };
    case EMPLEADOS_ERROR:
      return {
        ...state,
        refreshing: false,
        loading: false,
        error: action.payload.error,
      };
    case EMPLEADOS_OK:
      return {
        ...state,
        refreshing: false,
        loading: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
